module.exports = __webpack_public_path__ + "media/images/athletes/2491-50f14e626f9d91a99c5dd6cb602aeaf0.png";